import axios from 'axios';
import { 
  mockAuthService, 
  mockTaskService, 
  mockMessageService,
  mockUploadService
} from './mockApi';

// Usar API simulada en desarrollo o cuando no hay backend
const USE_MOCK_API = true; // Cambiar a false cuando quieras usar el backend real

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// Crear instancia de axios con URL base
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor para añadir token a peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores en las respuestas
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Error en petición API:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Servicios de autenticación
export const authService = USE_MOCK_API ? mockAuthService : {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (token, password) => api.post('/auth/reset-password', { token, password }),
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (data) => api.put('/auth/profile', data)
};

// Servicios de tareas
export const taskService = USE_MOCK_API ? mockTaskService : {
  getTasks: (filters) => api.get('/tasks', { params: filters }),
  getTaskById: (id) => api.get(`/tasks/${id}`),
  createTask: (taskData) => api.post('/tasks', taskData),
  acceptTask: (id) => api.post(`/tasks/${id}/accept`),
  completeTask: (id) => api.post(`/tasks/${id}/complete`),
  approveTask: (id) => api.post(`/tasks/${id}/approve`)
};

// Servicios de mensajería
export const messageService = USE_MOCK_API ? mockMessageService : {
  getChatHistory: (roomId) => api.get(`/messages/room/${roomId}`),
  sendMessage: (messageData) => api.post('/messages', messageData)
};

// Servicio de carga de archivos
export const uploadService = USE_MOCK_API ? mockUploadService : {
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};

// Servicios de administración
export const adminService = USE_MOCK_API ? {
  getStats: async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    
    return {
      data: {
        users: {
          total: 125,
          active: 87,
          newThisMonth: 23
        },
        tasks: {
          total: 430,
          pending: 86,
          completed: 344
        },
        transactions: {
          total: 344,
          volume: {
            blue: 23450,
            red: 28900
          }
        }
      }
    };
  },
  
  getUsers: async (params) => {
    await new Promise(resolve => setTimeout(resolve, 600));
    
    // Generar usuarios de muestra
    const users = [
      {
        id: '1',
        name: 'Usuario Demo',
        email: 'demo@example.com',
        isActive: true,
        tokensBlue: 100,
        tokensRed: 50,
        createdAt: new Date(Date.now() - 86400000 * 30).toISOString(),
      },
      // Más usuarios simulados...
    ];
    
    return { data: users };
  },
  
  updateSystemConfig: async (configData) => {
    await new Promise(resolve => setTimeout(resolve, 700));
    
    return {
      data: {
        message: 'Configuración actualizada correctamente',
        config: configData
      }
    };
  }
} : {
  getStats: () => api.get('/admin/stats'),
  getUsers: (params) => api.get('/admin/users', { params }),
  updateSystemConfig: (configData) => api.put('/admin/config', configData)
};

export default api;
